var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"progress-container h-[3px] fixed w-full z-100 bg-blackly"},[_c('div',{staticClass:"progress-bar h-full bg-br-green",style:(`width: ${_vm.progress}%`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }